export interface IOrderHistoryItem {
    orderID: number;
    orderNum: string;
    ccType: string;
    ccLast4: string;
    orderAmount: number;
    orderDate: Date;
    userID: string;
    orderStatus: string;
    productName: string;
    quantity: number;
}

export interface IUserTextVoiceData {
    textTimes: string[];
    voiceAlertNumber: string;
    textAlertNumber: string;
    twilioNumber: string;
    textStatus: number;
}

export type TNotification = "voiceAlerts" | "textAlerts";
export type TNotificationTarget = "lockAlerts" | "marketUpdates" | "morningUpdate";

// Email preferences are not here: every MBS email opt-in (including Strike Rate) lives in the
// LR/Braze notification settings, keyed `mbs_*` — see ILRNotificationSettings.
export type INotifications = {
    voiceAlerts: { lockAlerts: boolean };
    textAlerts: { lockAlerts: boolean; marketUpdates: boolean; morningUpdate: boolean };
};

export const notificationPaths = [
    "voiceAlerts.lockAlerts",
    "textAlerts.lockAlerts",
    "textAlerts.marketUpdates",
    "textAlerts.morningUpdate",
] as const;

export type TNotificationPath = (typeof notificationPaths)[number];
